import Pusher from 'pusher-js';

export const pusher = new Pusher(import.meta.env['VITE_NX_PUSHER_KEY'], {
  cluster: 'eu',
  authEndpoint: `${import.meta.env['VITE_NX_SERVER']}/project/pusher/auth`,
});

/**
 * Unique client ID for this browser session
 * Used to filter out our own client-triggered events
 */
export const clientId = crypto.randomUUID();

/**
 * Subscribe to a private project channel for real-time property updates
 * Private channels enable client-triggered events
 */
export const subscribeToPrivateProjectChannel = (projectId: string) => {
  const channel = pusher.subscribe(`private-project-${projectId}`);

  channel.bind('pusher:subscription_error', (error: unknown) => {
    console.error('[Pusher] Subscription error for:', `private-project-${projectId}`, error);
  });

  return channel;
};

/**
 * Unsubscribe from a private project channel
 */
export const unsubscribeFromPrivateProjectChannel = (projectId: string) => {
  pusher.unsubscribe(`private-project-${projectId}`);
};
